export const translations = {
  en: {
    // Navigation
    nav: {
      dashboard: "Dashboard",
      dashboardDesc: "Overview & analytics",
      paymentLinks: "Payment Links",
      paymentLinksDesc: "Manage your links",
      store: "Store",
      storeDesc: "Your public storefront",
      settings: "Settings",
      settingsDesc: "Account preferences",
      withdraw: "Withdraw Money",
      withdrawDesc: "Manage payouts",
      logout: "Logout",
      menu: "Menu",
    },
    // Auth
    auth: {
      login: "Sign In",
      register: "Create Account",
      email: "Email",
      password: "Password",
      name: "Full Name",
      forgotPassword: "Forgot password?",
      forgotPasswordDesc: "Enter your email and we'll send you a reset link",
      sendResetLink: "Send reset link",
      sending: "Sending...",
      resetEmailSent: "Email sent!",
      resetEmailSentDesc: "Check your inbox for the password reset link. It expires in 1 hour.",
      backToLogin: "Back to login",
      resetPassword: "Reset password",
      resetPasswordDesc: "Choose a new password for your account",
      newPassword: "New password",
      confirmPassword: "Confirm password",
      passwordTooShort: "Password must be at least 6 characters",
      passwordsDoNotMatch: "Passwords do not match",
      passwordResetSuccess: "Password reset!",
      passwordResetSuccessDesc: "Your password has been changed. You can now sign in.",
      resetting: "Resetting...",
      invalidResetLink: "This reset link is invalid or has expired.",
      noAccount: "Don't have an account?",
      hasAccount: "Already have an account?",
      signUp: "Sign up",
      signIn: "Sign in",
      welcomeBack: "Welcome back",
      createAccount: "Create your account",
      subtitle: "Access your creator dashboard",
      registerSubtitle: "Start selling your digital content",
      signingIn: "Signing in...",
      creatingAccount: "Creating account...",
      // Hero section
      heroTitle: "Sell your media instantly",
      heroSubtitle: "Create payment links, boost your conversion and build trust with your customers.",
      heroDesc: "With Ellalink, your buyers pay more easily thanks to a secure platform designed to maximize your sales.",
      startSellingTitle: "Start selling today",
      startSellingSubtitle: "Join thousands of creators who monetize their digital content with Ellalink.",
      // Stats
      creatorsCount: "+1,000",
      creatorsLabel: "Active creators",
      paymentsCount: "200,000+",
      paymentsLabel: "Payments processed",
      // Trust badges
      securePayments: "Secure payments",
      trustedPlatform: "Trusted platform",
    },
    // Dashboard
    dashboard: {
      title: "Dashboard",
      subtitle: "Track your earnings and performance in real-time",
      totalRevenue: "Total Revenue",
      todayRevenue: "Today's Revenue",
      monthlyRevenue: "Monthly Revenue",
      totalSales: "Total Sales",
      conversionRate: "Conversion Rate",
      totalViews: "Total Views",
      earnings: "Your Earnings",
      netEarnings: "Net Earnings",
      commission: "Platform Commission",
      recentPayments: "Recent Payments",
      bestPerforming: "Best Performing Links",
      noSales: "No sales yet",
      startSelling: "Create your first payment link to start selling",
      customerPays: "Customer Pays",
      youReceive: "You Receive",
      quickStats: "Quick Stats",
      revenueOverview: "Revenue Overview",
      last30Days: "Last 30 Days",
      vsLastWeek: "vs last week",
      views: "views",
      sales: "sales",
      noRevenueData: "No revenue data yet",
      startSellingAnalytics: "Start selling to see your analytics",
      paymentsAppearHere: "Payments will appear here",
      createPaymentLink: "Create Payment Link",
      totalEarnings: "Total Earnings",
      todayEarnings: "Today's Earnings",
      monthlyEarnings: "Monthly Earnings",
    },
    commission: {
      title: "Commission",
      subtitle: "Track your platform commission earnings",
      totalCommission: "Total Commission",
      monthlyCommission: "This Month",
      totalVolume: "Total Volume",
      transactions: "Transactions",
      payoutAccount: "Payout Account",
      accountHolder: "Account Holder",
      recentCommissions: "Recent Commissions",
      buyerPaid: "Buyer Paid",
      creatorGets: "Creator Gets",
      yourCommission: "Your Commission",
      noCommissions: "No commissions yet",
      noCommissionsDesc: "Commissions will appear here when sales are made",
      stripePayoutTitle: "Stripe Automatic Payouts",
      stripePayoutDesc: "All payments go through your Stripe account. Stripe automatically transfers your balance to the bank account configured in your Stripe Dashboard.",
      stripePayoutSchedule: "Payout schedule: configurable in your Stripe Dashboard (daily, weekly, monthly)",
      stripePayoutAction: "Open Stripe Dashboard",
      flux1Label: "Flux 1 — Creator",
      flux1Desc: "100% of the set price",
      flux2Label: "Flux 2 — Platform",
      flux2Desc: "10% commission added to buyer",
    },
    adminWithdraw: {
      title: "Creator Withdrawals",
      subtitle: "Manage creator IBANs and withdrawal requests",
      creatorsWithIban: "Creators with IBAN",
      pendingRequests: "Pending requests",
      totalPending: "Total pending",
      withdrawals: "Withdrawals",
      creatorsIban: "Creator IBANs",
      searchPlaceholder: "Search by email, name or IBAN...",
      all: "All",
      pending: "Pending",
      paid: "Paid",
      rejected: "Rejected",
      noWithdrawals: "No withdrawal requests yet",
      noCreators: "No creators with IBAN registered",
      accountName: "Name",
      bank: "Bank",
      addedOn: "Added",
      availableBalance: "Available balance",
      markPaid: "Mark paid",
      reject: "Reject",
      markedPaid: "Withdrawal marked as paid",
      markedRejected: "Withdrawal rejected",
      processedOn: "Processed",
      withdrawalDay: "Withdrawals are available on Tuesdays only (from 00:00, Paris time)",
      nextWithdrawal: "Next withdrawal",
      deleteIban: "Delete IBAN",
      confirmDeleteIban: "Are you sure you want to delete this IBAN?",
      ibanDeleted: "IBAN deleted",
    },
    support: {
      title: "Support",
      subtitle: "Need help? Contact our team",
      emailUs: "Email us",
      responseTime: "Response time",
      responseTimeDesc: "Less than 24 hours",
      contactForm: "Contact form",
      contactFormDesc: "Fill out the form below and we'll get back to you as soon as possible.",
      yourEmail: "Your email",
      subject: "Subject",
      subjectPlaceholder: "How can we help?",
      message: "Message",
      messagePlaceholder: "Describe your issue or question in detail...",
      send: "Send message",
      sending: "Sending...",
      messageSent: "Message sent successfully!",
      sendError: "Failed to send message. Please try again.",
      thankYou: "Message sent!",
      thankYouDesc: "Thank you for contacting us. We will respond within 24 hours.",
      sendAnother: "Send another message",
    },
    // Payment Links
    links: {
      title: "Payment Links",
      subtitle: "Create and manage your payment links",
      create: "Create Link",
      edit: "Edit Link",
      delete: "Delete",
      noLinks: "No payment links yet",
      createFirst: "Create your first payment link",
      linkTitle: "Title",
      description: "Description",
      price: "Your Price",
      customerPrice: "Customer Pays",
      currency: "Currency",
      previewImage: "Preview Image",
      blurPreview: "Blur Preview",
      blurPreviewDesc: "Blur the preview until purchase",
      buttonText: "Button Text",
      successMessage: "Success Message",
      uploadMedia: "Upload Media",
      uploadMediaDesc: "Click to upload your digital content",
      uploadMediaTypes: "PDF, Video, Image, or any file type",
      clickToChange: "Click to change file",
      replaceMedia: "Replace",
      removeMedia: "Remove",
      mediaRemoved: "Media removed",
      copyLink: "Copy Link",
      linkCopied: "Link copied!",
      preview: "Preview",
      copied: "Copied!",
      views: "Views",
      sales: "Sales",
      active: "Active",
      inactive: "Inactive",
      priceNote: "Customer will pay 10% more",
      revenue: "Revenue",
      titlePlaceholder: "e.g., Premium Video Course",
      descriptionPlaceholder: "Describe your digital content...",
      pricePlaceholder: "9.99",
      buttonTextPlaceholder: "Buy Now",
      successMessagePlaceholder: "Thank you for your purchase!",
      linkUpdated: "Payment link updated successfully!",
      linkCreated: "Payment link created successfully!",
      mediaUploaded: "Media file uploaded!",
      linkDeleted: "Payment link deleted",
      failedToLoad: "Failed to load payment links",
      failedToSave: "Failed to save payment link",
      failedToDelete: "Failed to delete payment link",
      saving: "Saving...",
      confirmDelete: "Are you sure you want to delete this payment link?",
    },
    // Settings
    settings: {
      title: "Settings",
      subtitle: "Manage your account settings and preferences",
      profile: "Profile",
      profileDesc: "Update your personal information",
      branding: "Branding",
      appearance: "Appearance",
      appearanceDesc: "Customize your interface theme",
      language: "Language",
      languageDesc: "Choose your preferred language",
      darkMode: "Dark Mode",
      lightMode: "Light Mode",
      saveChanges: "Save Changes",
      saving: "Saving...",
      bio: "Bio",
      bioPlaceholder: "Tell your audience about yourself...",
      storeSlug: "Store URL",
      avatar: "Avatar",
      uploadAvatar: "Upload Avatar",
      removeAvatar: "Remove photo",
      avatarRemoved: "Avatar removed",
      profileUpdated: "Profile updated successfully!",
      failedToUpdate: "Failed to update profile",
      toggleTheme: "Toggle between light and dark theme",
      cleanBright: "Clean & bright",
      easyOnEyes: "Easy on the eyes",
      interfaceLanguage: "Interface Language",
    },
    // Store
    store: {
      title: "Your Store",
      subtitle: "Preview and share your public store",
      preview: "Preview Store",
      products: "Products",
      noProducts: "No products available",
      items: "items",
      storeUrl: "Your Public Store URL",
      copyUrl: "Copy URL",
      copied: "Copied!",
      storePreview: "Store Preview",
      createToShow: "Create payment links to show products in your store",
      storeNotFound: "Store Not Found",
      storeNotFoundDesc: "This store doesn't exist or has been removed.",
      poweredBy: "Powered by",
      securePayments: "Secure payments",
      noProductsCreator: "This creator hasn't added any products yet.",
      buyNow: "Buy Now",
    },
    // Payment
    payment: {
      pay: "Pay",
      processing: "Processing...",
      success: "Payment Successful!",
      thankYou: "Thank you for your purchase",
      download: "Download Content",
      accessContent: "Access Your Content",
      methods: "Payment Methods",
      creditCard: "Credit Card",
      applePay: "Apple Pay",
      paypal: "PayPal",
      selectMethod: "Select payment method",
      securePayment: "Secure payment powered by Stripe",
      premiumContent: "Premium Content",
      unlockedAfterPurchase: "Unlocked after purchase",
      securePaymentBadge: "Secure Payment",
      instantDelivery: "Instant Delivery",
      creator: "Creator",
      linkNotFound: "Link Not Found",
      linkNotFoundDesc: "This payment link doesn't exist or has been removed.",
      verifyingPayment: "Verifying Payment...",
      pleaseWait: "Please wait while we confirm your payment",
      paymentProcessing: "Payment Processing",
      paymentStillProcessing: "Your payment is still being processed. This may take a moment.",
      checkAgain: "Check Again",
      sessionExpired: "Session Expired",
      sessionExpiredDesc: "Your payment session has expired. Please try again.",
      somethingWrong: "Something Went Wrong",
      somethingWrongDesc: "We couldn't verify your payment. If you were charged, please contact support.",
      goBack: "Go Back",
      tryAgain: "Try Again",
      yourPurchase: "Your Purchase",
      saveThisPage: "Save this page to access your content later",
      mediaPrice: "Media price",
      platformCommission: "Platform commission (10%)",
      totalToPay: "Total to pay",
      commissionNote: "This small fee ensures fast, secure transactions and reliable content delivery.",
      videoNotSupported: "Your browser does not support video playback.",
      checkoutFailed: "Unable to start checkout. Please try again.",
      noCheckoutUrl: "Payment session could not be initialized. Please retry.",
    },
    // Withdraw
    withdraw: {
      title: "Withdraw Money",
      subtitle: "Manage your earnings and payouts",
      availableBalance: "Available Balance",
      pendingBalance: "Pending Balance",
      totalWithdrawn: "Total Withdrawn",
      withdrawFunds: "Withdraw Funds",
      withdrawalsOpen: "Withdrawals are open. One withdrawal per week is allowed.",
      payoutMethod: "Payout Method",
      payoutMethods: "Payout Methods",
      bankTransfer: "Bank Transfer",
      addBankAccount: "Add Bank Account",
      addMethod: "Add Method",
      bankDetails: "Bank Details",
      fullName: "Full Name",
      fullNamePlaceholder: "John Doe",
      iban: "IBAN",
      ibanPlaceholder: "FR76 XXXX XXXX XXXX XXXX XXXX XXX",
      bic: "BIC/SWIFT",
      bicPlaceholder: "XXXXXXXX",
      bankName: "Bank Name",
      bankNamePlaceholder: "Bank Name",
      country: "Country",
      withdrawAmount: "Withdrawal Amount",
      minWithdraw: "Minimum withdrawal",
      available: "Available",
      history: "Withdrawal History",
      historyDesc: "Your withdrawal history",
      noHistory: "No withdrawals yet",
      pending: "Pending",
      completed: "Completed",
      failed: "Failed",
      requestWithdraw: "Request Withdrawal",
      saveAccount: "Save Account",
      editAccount: "Edit Account",
      deleteAccount: "Delete Account",
      methodUpdated: "Payout method updated!",
      methodAdded: "Payout method added!",
      methodDeleted: "Payout method deleted",
      withdrawalSubmitted: "Withdrawal request submitted!",
      failedToSave: "Failed to save payout method",
      failedToDelete: "Failed to delete payout method",
      failedToRequest: "Failed to request withdrawal",
      noMethodsAdded: "No payout methods added",
      addMethodDesc: "Add a bank account to withdraw funds",
      confirmDeleteMethod: "Are you sure you want to delete this payout method?",
      managePayoutMethods: "Manage your payout methods",
    },
    // Common
    common: {
      loading: "Loading...",
      error: "An error occurred",
      save: "Save",
      cancel: "Cancel",
      confirm: "Confirm",
      search: "Search",
      filter: "Filter",
      sort: "Sort",
      actions: "Actions",
      status: "Status",
      date: "Date",
      amount: "Amount",
      back: "Back",
      next: "Next",
      submit: "Submit",
      close: "Close",
      edit: "Edit",
      delete: "Delete",
      view: "View",
      copy: "Copy",
      share: "Share",
      download: "Download",
      upload: "Upload",
      yes: "Yes",
      no: "No",
      or: "or",
      and: "and",
      of: "of",
      to: "to",
      from: "from",
    },
    // Errors
    errors: {
      required: "This field is required",
      invalidEmail: "Invalid email address",
      passwordTooShort: "Password must be at least 6 characters",
      passwordMismatch: "Passwords do not match",
      networkError: "Network error. Please try again.",
      unauthorized: "You are not authorized to perform this action",
      notFound: "Resource not found",
      serverError: "Server error. Please try again later.",
    },
    // Success messages
    success: {
      saved: "Changes saved successfully",
      deleted: "Deleted successfully",
      copied: "Copied to clipboard",
      updated: "Updated successfully",
    },
  },
  fr: {
    // Navigation
    nav: {
      dashboard: "Tableau de bord",
      dashboardDesc: "Aperçu et analytiques",
      paymentLinks: "Liens de paiement",
      paymentLinksDesc: "Gérer vos liens",
      store: "Boutique",
      storeDesc: "Votre vitrine publique",
      settings: "Paramètres",
      settingsDesc: "Préférences du compte",
      withdraw: "Retirer l'argent",
      withdrawDesc: "Gérer les paiements",
      logout: "Déconnexion",
      menu: "Menu",
    },
    // Auth
    auth: {
      login: "Connexion",
      register: "Créer un compte",
      email: "Email",
      password: "Mot de passe",
      name: "Nom complet",
      forgotPassword: "Mot de passe oublié ?",
      forgotPasswordDesc: "Entrez votre email et nous vous enverrons un lien de réinitialisation",
      sendResetLink: "Envoyer le lien",
      sending: "Envoi en cours...",
      resetEmailSent: "Email envoyé !",
      resetEmailSentDesc: "Vérifiez votre boîte de réception. Le lien expire dans 1 heure.",
      backToLogin: "Retour à la connexion",
      resetPassword: "Réinitialiser le mot de passe",
      resetPasswordDesc: "Choisissez un nouveau mot de passe pour votre compte",
      newPassword: "Nouveau mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères",
      passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
      passwordResetSuccess: "Mot de passe réinitialisé !",
      passwordResetSuccessDesc: "Votre mot de passe a été modifié. Vous pouvez maintenant vous connecter.",
      resetting: "Réinitialisation...",
      invalidResetLink: "Ce lien est invalide ou a expiré.",
      noAccount: "Pas encore de compte ?",
      hasAccount: "Déjà un compte ?",
      signUp: "S'inscrire",
      signIn: "Se connecter",
      welcomeBack: "Bienvenue",
      createAccount: "Créez votre compte",
      subtitle: "Accédez à votre tableau de bord créateur",
      registerSubtitle: "Commencez à vendre votre contenu numérique",
      signingIn: "Connexion en cours...",
      creatingAccount: "Création du compte...",
      // Hero section
      heroTitle: "Vendez vos médias instantanément",
      heroSubtitle: "Créez des liens de paiement, augmentez votre conversion et inspirez confiance à vos clients.",
      heroDesc: "Avec Ellalink, vos acheteurs paient plus facilement grâce à une plateforme sécurisée et conçue pour maximiser vos ventes.",
      startSellingTitle: "Commencez à vendre aujourd'hui",
      startSellingSubtitle: "Rejoignez des milliers de créateurs qui monétisent leur contenu numérique avec Ellalink.",
      // Stats
      creatorsCount: "+1 000",
      creatorsLabel: "Créateurs actifs",
      paymentsCount: "200 000+",
      paymentsLabel: "Paiements traités",
      // Trust badges
      securePayments: "Paiements sécurisés",
      trustedPlatform: "Plateforme de confiance",
    },
    // Dashboard
    dashboard: {
      title: "Tableau de bord",
      subtitle: "Suivez vos gains et performances en temps réel",
      totalRevenue: "Revenu total",
      todayRevenue: "Revenu du jour",
      monthlyRevenue: "Revenu mensuel",
      totalSales: "Ventes totales",
      conversionRate: "Taux de conversion",
      totalViews: "Vues totales",
      earnings: "Vos gains",
      netEarnings: "Gains nets",
      commission: "Commission plateforme",
      recentPayments: "Paiements récents",
      bestPerforming: "Meilleurs liens",
      noSales: "Pas encore de ventes",
      startSelling: "Créez votre premier lien de paiement pour commencer à vendre",
      customerPays: "Le client paie",
      youReceive: "Vous recevez",
      quickStats: "Statistiques rapides",
      revenueOverview: "Aperçu des revenus",
      last30Days: "30 derniers jours",
      vsLastWeek: "vs semaine dernière",
      views: "vues",
      sales: "ventes",
      noRevenueData: "Pas encore de données de revenus",
      startSellingAnalytics: "Commencez à vendre pour voir vos analytiques",
      paymentsAppearHere: "Les paiements apparaîtront ici",
      createPaymentLink: "Créer un lien de paiement",
      netYourEarnings: "Net Vos gains",
      totalEarnings: "Gains totaux",
      todayEarnings: "Gains du jour",
      monthlyEarnings: "Gains mensuels",
    },
    commission: {
      title: "Commission",
      subtitle: "Suivez vos commissions de plateforme",
      totalCommission: "Commission totale",
      monthlyCommission: "Ce mois",
      totalVolume: "Volume total",
      transactions: "Transactions",
      payoutAccount: "Compte de versement",
      accountHolder: "Titulaire du compte",
      recentCommissions: "Commissions récentes",
      buyerPaid: "Acheteur a payé",
      creatorGets: "Créateur reçoit",
      yourCommission: "Votre commission",
      noCommissions: "Pas encore de commissions",
      noCommissionsDesc: "Les commissions apparaîtront ici lorsque des ventes seront réalisées",
      stripePayoutTitle: "Versements Stripe automatiques",
      stripePayoutDesc: "Tous les paiements passent par votre compte Stripe. Stripe transfère automatiquement votre solde vers le compte bancaire configuré dans votre Dashboard Stripe.",
      stripePayoutSchedule: "Fréquence de versement : configurable dans votre Dashboard Stripe (quotidien, hebdomadaire, mensuel)",
      stripePayoutAction: "Ouvrir le Dashboard Stripe",
      flux1Label: "Flux 1 — Créateur",
      flux1Desc: "100% du prix fixé",
      flux2Label: "Flux 2 — Plateforme",
      flux2Desc: "10% de commission ajoutée à l'acheteur",
    },
    adminWithdraw: {
      title: "Retraits créateurs",
      subtitle: "Gérez les IBAN et demandes de retrait des créateurs",
      creatorsWithIban: "Créateurs avec IBAN",
      pendingRequests: "Demandes en attente",
      totalPending: "Total en attente",
      withdrawals: "Retraits",
      creatorsIban: "IBAN créateurs",
      searchPlaceholder: "Rechercher par email, nom ou IBAN...",
      all: "Tous",
      pending: "En attente",
      paid: "Payé",
      rejected: "Refusé",
      noWithdrawals: "Aucune demande de retrait",
      noCreators: "Aucun créateur avec IBAN enregistré",
      accountName: "Nom",
      bank: "Banque",
      addedOn: "Ajouté",
      availableBalance: "Solde disponible",
      markPaid: "Marquer payé",
      reject: "Refuser",
      markedPaid: "Retrait marqué comme payé",
      markedRejected: "Retrait refusé",
      processedOn: "Traité",
      withdrawalDay: "Les retraits sont disponibles uniquement le mardi (à partir de 00h00, heure de Paris)",
      nextWithdrawal: "Prochain retrait",
      deleteIban: "Supprimer l'IBAN",
      confirmDeleteIban: "Êtes-vous sûr de vouloir supprimer cet IBAN ?",
      ibanDeleted: "IBAN supprimé",
    },
    support: {
      title: "Support",
      subtitle: "Besoin d'aide ? Contactez notre équipe",
      emailUs: "Envoyez-nous un email",
      responseTime: "Temps de réponse",
      responseTimeDesc: "Moins de 24 heures",
      contactForm: "Formulaire de contact",
      contactFormDesc: "Remplissez le formulaire ci-dessous et nous vous répondrons dans les plus brefs délais.",
      yourEmail: "Votre email",
      subject: "Objet",
      subjectPlaceholder: "Comment pouvons-nous vous aider ?",
      message: "Message",
      messagePlaceholder: "Décrivez votre problème ou votre question en détail...",
      send: "Envoyer le message",
      sending: "Envoi en cours...",
      messageSent: "Message envoyé avec succès !",
      sendError: "Échec de l'envoi. Veuillez réessayer.",
      thankYou: "Message envoyé !",
      thankYouDesc: "Merci de nous avoir contactés. Nous vous répondrons dans les 24 heures.",
      sendAnother: "Envoyer un autre message",
    },
    // Payment Links
    links: {
      title: "Liens de paiement",
      subtitle: "Créez et gérez vos liens de paiement",
      create: "Créer un lien",
      edit: "Modifier",
      delete: "Supprimer",
      noLinks: "Aucun lien de paiement",
      createFirst: "Créez votre premier lien de paiement",
      linkTitle: "Titre",
      description: "Description",
      price: "Votre prix",
      customerPrice: "Le client paie",
      currency: "Devise",
      previewImage: "Image d'aperçu",
      blurPreview: "Flouter l'aperçu",
      blurPreviewDesc: "Flouter l'aperçu jusqu'à l'achat",
      buttonText: "Texte du bouton",
      successMessage: "Message de succès",
      uploadMedia: "Télécharger le média",
      uploadMediaDesc: "Cliquez pour télécharger votre contenu numérique",
      uploadMediaTypes: "PDF, Vidéo, Image ou tout type de fichier",
      clickToChange: "Cliquez pour changer le fichier",
      replaceMedia: "Remplacer",
      removeMedia: "Supprimer",
      mediaRemoved: "Média supprimé",
      copyLink: "Copier le lien",
      linkCopied: "Lien copié !",
      preview: "Apercu",
      copied: "Copie !",
      views: "Vues",
      sales: "Ventes",
      active: "Actif",
      inactive: "Inactif",
      priceNote: "Le client paiera 10% de plus",
      revenue: "Revenus",
      titlePlaceholder: "ex: Cours vidéo premium",
      descriptionPlaceholder: "Décrivez votre contenu numérique...",
      pricePlaceholder: "9.99",
      buttonTextPlaceholder: "Acheter",
      successMessagePlaceholder: "Merci pour votre achat !",
      linkUpdated: "Lien de paiement mis à jour !",
      linkCreated: "Lien de paiement créé !",
      mediaUploaded: "Fichier média téléchargé !",
      linkDeleted: "Lien de paiement supprimé",
      failedToLoad: "Échec du chargement des liens",
      failedToSave: "Échec de l'enregistrement",
      failedToDelete: "Échec de la suppression",
      saving: "Enregistrement...",
      confirmDelete: "Êtes-vous sûr de vouloir supprimer ce lien ?",
    },
    // Settings
    settings: {
      title: "Paramètres",
      subtitle: "Gérez les paramètres de votre compte et vos préférences",
      profile: "Profil",
      profileDesc: "Mettez à jour vos informations personnelles",
      branding: "Marque",
      appearance: "Apparence",
      appearanceDesc: "Personnalisez le thème de votre interface",
      language: "Langue",
      languageDesc: "Choisissez votre langue préférée",
      darkMode: "Mode sombre",
      lightMode: "Mode clair",
      saveChanges: "Enregistrer",
      saving: "Enregistrement...",
      bio: "Biographie",
      bioPlaceholder: "Parlez de vous à votre audience...",
      storeSlug: "URL de boutique",
      avatar: "Avatar",
      uploadAvatar: "Télécharger l'avatar",
      removeAvatar: "Supprimer la photo",
      avatarRemoved: "Photo supprimée",
      profileUpdated: "Profil mis à jour !",
      failedToUpdate: "Échec de la mise à jour du profil",
      toggleTheme: "Basculer entre le mode clair et sombre",
      cleanBright: "Clair et lumineux",
      easyOnEyes: "Agréable pour les yeux",
      interfaceLanguage: "Langue de l'interface",
    },
    // Store
    store: {
      title: "Votre boutique",
      subtitle: "Prévisualisez et partagez votre boutique publique",
      preview: "Aperçu",
      products: "Produits",
      noProducts: "Aucun produit disponible",
      items: "articles",
      storeUrl: "URL de votre boutique publique",
      copyUrl: "Copier l'URL",
      copied: "Copié !",
      storePreview: "Aperçu de la boutique",
      createToShow: "Créez des liens de paiement pour afficher des produits dans votre boutique",
      storeNotFound: "Boutique introuvable",
      storeNotFoundDesc: "Cette boutique n'existe pas ou a été supprimée.",
      poweredBy: "Propulsé par",
      securePayments: "Paiements sécurisés",
      noProductsCreator: "Ce créateur n'a pas encore ajouté de produits.",
      buyNow: "Acheter",
    },
    // Payment
    payment: {
      pay: "Payer",
      processing: "Traitement...",
      success: "Paiement réussi !",
      thankYou: "Merci pour votre achat",
      download: "Télécharger le contenu",
      accessContent: "Accéder au contenu",
      methods: "Méthodes de paiement",
      creditCard: "Carte bancaire",
      applePay: "Apple Pay",
      selectMethod: "Choisir la méthode de paiement",
      securePayment: "Paiement sécurisé via Stripe",
      premiumContent: "Contenu premium",
      unlockedAfterPurchase: "Débloqué après achat",
      securePaymentBadge: "Paiement sécurisé",
      instantDelivery: "Livraison instantanée",
      creator: "Créateur",
      linkNotFound: "Lien introuvable",
      linkNotFoundDesc: "Ce lien de paiement n'existe pas ou a été supprimé.",
      verifyingPayment: "Vérification du paiement...",
      pleaseWait: "Veuillez patienter pendant que nous confirmons votre paiement",
      paymentProcessing: "Paiement en cours",
      paymentStillProcessing: "Votre paiement est toujours en cours de traitement. Cela peut prendre un moment.",
      checkAgain: "Vérifier à nouveau",
      sessionExpired: "Session expirée",
      sessionExpiredDesc: "Votre session de paiement a expiré. Veuillez réessayer.",
      somethingWrong: "Une erreur s'est produite",
      somethingWrongDesc: "Nous n'avons pas pu vérifier votre paiement. Si vous avez été débité, veuillez contacter le support.",
      goBack: "Retour",
      tryAgain: "Réessayer",
      yourPurchase: "Votre achat",
      saveThisPage: "Enregistrez cette page pour accéder à votre contenu plus tard",
      mediaPrice: "Prix du contenu",
      platformCommission: "Commission plateforme (10%)",
      totalToPay: "Total à payer",
      commissionNote: "Ce petit frais garantit des transactions rapides, sécurisées et une livraison fiable du contenu.",
      videoNotSupported: "Votre navigateur ne prend pas en charge la lecture vidéo.",
      checkoutFailed: "Impossible de démarrer le paiement. Veuillez réessayer.",
      noCheckoutUrl: "La session de paiement n'a pas pu être initialisée. Veuillez réessayer.",
    },
    // Withdraw
    withdraw: {
      title: "Retirer l'argent",
      subtitle: "Gérez vos gains et paiements",
      availableBalance: "Solde disponible",
      pendingBalance: "Solde en attente",
      totalWithdrawn: "Total retiré",
      withdrawFunds: "Retirer des fonds",
      withdrawalsOpen: "Les retraits sont ouverts. Un retrait par semaine est autorisé.",
      payoutMethod: "Méthode de paiement",
      payoutMethods: "Méthodes de paiement",
      bankTransfer: "Virement bancaire",
      addBankAccount: "Ajouter un compte bancaire",
      addMethod: "Ajouter une méthode",
      bankDetails: "Coordonnées bancaires",
      fullName: "Nom complet",
      fullNamePlaceholder: "Jean Dupont",
      iban: "IBAN",
      ibanPlaceholder: "FR76 XXXX XXXX XXXX XXXX XXXX XXX",
      bic: "BIC/SWIFT",
      bicPlaceholder: "XXXXXXXX",
      bankName: "Nom de la banque",
      bankNamePlaceholder: "Nom de la banque",
      country: "Pays",
      withdrawAmount: "Montant du retrait",
      minWithdraw: "Retrait minimum",
      available: "Disponible",
      history: "Historique des retraits",
      historyDesc: "Votre historique de retraits",
      noHistory: "Aucun retrait",
      pending: "En attente",
      completed: "Terminé",
      failed: "Échoué",
      requestWithdraw: "Demander un retrait",
      saveAccount: "Enregistrer le compte",
      editAccount: "Modifier le compte",
      deleteAccount: "Supprimer le compte",
      methodUpdated: "Méthode de paiement mise à jour !",
      methodAdded: "Méthode de paiement ajoutée !",
      methodDeleted: "Méthode de paiement supprimée",
      withdrawalSubmitted: "Demande de retrait soumise !",
      failedToSave: "Échec de l'enregistrement",
      failedToDelete: "Échec de la suppression",
      failedToRequest: "Échec de la demande de retrait",
      noMethodsAdded: "Aucune méthode de paiement ajoutée",
      addMethodDesc: "Ajoutez un compte bancaire pour retirer des fonds",
      confirmDeleteMethod: "Êtes-vous sûr de vouloir supprimer cette méthode de paiement ?",
      managePayoutMethods: "Gérez vos méthodes de paiement",
    },
    // Common
    common: {
      loading: "Chargement...",
      error: "Une erreur s'est produite",
      save: "Enregistrer",
      cancel: "Annuler",
      confirm: "Confirmer",
      search: "Rechercher",
      filter: "Filtrer",
      sort: "Trier",
      actions: "Actions",
      status: "Statut",
      date: "Date",
      amount: "Montant",
      back: "Retour",
      next: "Suivant",
      submit: "Soumettre",
      close: "Fermer",
      edit: "Modifier",
      delete: "Supprimer",
      view: "Voir",
      copy: "Copier",
      share: "Partager",
      download: "Télécharger",
      upload: "Télécharger",
      yes: "Oui",
      no: "Non",
      or: "ou",
      and: "et",
      of: "de",
      to: "à",
      from: "de",
    },
    // Errors
    errors: {
      required: "Ce champ est obligatoire",
      invalidEmail: "Adresse email invalide",
      passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères",
      passwordMismatch: "Les mots de passe ne correspondent pas",
      networkError: "Erreur réseau. Veuillez réessayer.",
      unauthorized: "Vous n'êtes pas autorisé à effectuer cette action",
      notFound: "Ressource introuvable",
      serverError: "Erreur serveur. Veuillez réessayer plus tard.",
    },
    // Success messages
    success: {
      saved: "Modifications enregistrées",
      deleted: "Supprimé avec succès",
      copied: "Copié dans le presse-papiers",
      updated: "Mis à jour avec succès",
    },
  },
  es: {
    // Navigation
    nav: {
      dashboard: "Panel",
      dashboardDesc: "Resumen y analíticas",
      paymentLinks: "Enlaces de pago",
      paymentLinksDesc: "Gestionar tus enlaces",
      store: "Tienda",
      storeDesc: "Tu escaparate público",
      settings: "Configuración",
      settingsDesc: "Preferencias de cuenta",
      withdraw: "Retirar dinero",
      withdrawDesc: "Gestionar pagos",
      logout: "Cerrar sesión",
      menu: "Menú",
    },
    // Auth
    auth: {
      login: "Iniciar sesión",
      register: "Crear cuenta",
      email: "Correo electrónico",
      password: "Contraseña",
      name: "Nombre completo",
      forgotPassword: "¿Olvidaste tu contraseña?",
      forgotPasswordDesc: "Ingresa tu email y te enviaremos un enlace para restablecer",
      sendResetLink: "Enviar enlace",
      sending: "Enviando...",
      resetEmailSent: "¡Email enviado!",
      resetEmailSentDesc: "Revisa tu bandeja de entrada. El enlace expira en 1 hora.",
      backToLogin: "Volver al inicio de sesión",
      resetPassword: "Restablecer contraseña",
      resetPasswordDesc: "Elige una nueva contraseña para tu cuenta",
      newPassword: "Nueva contraseña",
      confirmPassword: "Confirmar contraseña",
      passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
      passwordsDoNotMatch: "Las contraseñas no coinciden",
      passwordResetSuccess: "¡Contraseña restablecida!",
      passwordResetSuccessDesc: "Tu contraseña ha sido cambiada. Ya puedes iniciar sesión.",
      resetting: "Restableciendo...",
      invalidResetLink: "Este enlace es inválido o ha expirado.",
      noAccount: "¿No tienes cuenta?",
      hasAccount: "¿Ya tienes cuenta?",
      signUp: "Registrarse",
      signIn: "Iniciar sesión",
      welcomeBack: "Bienvenido",
      createAccount: "Crea tu cuenta",
      subtitle: "Accede a tu panel de creador",
      registerSubtitle: "Empieza a vender tu contenido digital",
      signingIn: "Iniciando sesión...",
      creatingAccount: "Creando cuenta...",
      // Hero section
      heroTitle: "Vende tus medios al instante",
      heroSubtitle: "Crea enlaces de pago, aumenta tu conversión e inspira confianza a tus clientes.",
      heroDesc: "Con Ellalink, tus compradores pagan más fácilmente gracias a una plataforma segura diseñada para maximizar tus ventas.",
      startSellingTitle: "Empieza a vender hoy",
      startSellingSubtitle: "Únete a miles de creadores que monetizan su contenido digital con Ellalink.",
      // Stats
      creatorsCount: "+1.000",
      creatorsLabel: "Creadores activos",
      paymentsCount: "200.000+",
      paymentsLabel: "Pagos procesados",
      // Trust badges
      securePayments: "Pagos seguros",
      trustedPlatform: "Plataforma de confianza",
    },
    // Dashboard
    dashboard: {
      title: "Panel",
      subtitle: "Sigue tus ganancias y rendimiento en tiempo real",
      totalRevenue: "Ingresos totales",
      todayRevenue: "Ingresos de hoy",
      monthlyRevenue: "Ingresos mensuales",
      totalSales: "Ventas totales",
      conversionRate: "Tasa de conversión",
      totalViews: "Vistas totales",
      earnings: "Tus ganancias",
      netEarnings: "Ganancias netas",
      commission: "Comisión plataforma",
      recentPayments: "Pagos recientes",
      bestPerforming: "Mejores enlaces",
      noSales: "Sin ventas aún",
      startSelling: "Crea tu primer enlace de pago para empezar a vender",
      customerPays: "El cliente paga",
      youReceive: "Tú recibes",
      quickStats: "Estadísticas rápidas",
      revenueOverview: "Resumen de ingresos",
      last30Days: "Últimos 30 días",
      vsLastWeek: "vs semana pasada",
      views: "vistas",
      sales: "ventas",
      noRevenueData: "Sin datos de ingresos aún",
      startSellingAnalytics: "Empieza a vender para ver tus analíticas",
      paymentsAppearHere: "Los pagos aparecerán aquí",
      createPaymentLink: "Crear enlace de pago",
      netYourEarnings: "Net Tus ganancias",
      totalEarnings: "Ganancias totales",
      todayEarnings: "Ganancias de hoy",
      monthlyEarnings: "Ganancias mensuales",
    },
    commission: {
      title: "Comisión",
      subtitle: "Sigue tus comisiones de la plataforma",
      totalCommission: "Comisión total",
      monthlyCommission: "Este mes",
      totalVolume: "Volumen total",
      transactions: "Transacciones",
      payoutAccount: "Cuenta de pago",
      accountHolder: "Titular de la cuenta",
      recentCommissions: "Comisiones recientes",
      buyerPaid: "Comprador pagó",
      creatorGets: "Creador recibe",
      yourCommission: "Tu comisión",
      noCommissions: "Sin comisiones aún",
      noCommissionsDesc: "Las comisiones aparecerán aquí cuando se realicen ventas",
      stripePayoutTitle: "Pagos automáticos de Stripe",
      stripePayoutDesc: "Todos los pagos pasan por tu cuenta Stripe. Stripe transfiere automáticamente tu saldo a la cuenta bancaria configurada en tu Dashboard de Stripe.",
      stripePayoutSchedule: "Frecuencia de pago: configurable en tu Dashboard de Stripe (diario, semanal, mensual)",
      stripePayoutAction: "Abrir Dashboard de Stripe",
      flux1Label: "Flujo 1 — Creador",
      flux1Desc: "100% del precio fijado",
      flux2Label: "Flujo 2 — Plataforma",
      flux2Desc: "10% de comisión añadida al comprador",
    },
    adminWithdraw: {
      title: "Retiros de creadores",
      subtitle: "Gestiona los IBAN y solicitudes de retiro de creadores",
      creatorsWithIban: "Creadores con IBAN",
      pendingRequests: "Solicitudes pendientes",
      totalPending: "Total pendiente",
      withdrawals: "Retiros",
      creatorsIban: "IBAN creadores",
      searchPlaceholder: "Buscar por email, nombre o IBAN...",
      all: "Todos",
      pending: "Pendiente",
      paid: "Pagado",
      rejected: "Rechazado",
      noWithdrawals: "Sin solicitudes de retiro",
      noCreators: "Sin creadores con IBAN registrado",
      accountName: "Nombre",
      bank: "Banco",
      addedOn: "Agregado",
      availableBalance: "Saldo disponible",
      markPaid: "Marcar pagado",
      reject: "Rechazar",
      markedPaid: "Retiro marcado como pagado",
      markedRejected: "Retiro rechazado",
      processedOn: "Procesado",
      withdrawalDay: "Los retiros están disponibles solo los martes (desde las 00:00, hora de París)",
      nextWithdrawal: "Próximo retiro",
      deleteIban: "Eliminar IBAN",
      confirmDeleteIban: "¿Estás seguro de que quieres eliminar este IBAN?",
      ibanDeleted: "IBAN eliminado",
    },
    support: {
      title: "Soporte",
      subtitle: "¿Necesitas ayuda? Contacta a nuestro equipo",
      emailUs: "Envíanos un email",
      responseTime: "Tiempo de respuesta",
      responseTimeDesc: "Menos de 24 horas",
      contactForm: "Formulario de contacto",
      contactFormDesc: "Completa el formulario y te responderemos lo antes posible.",
      yourEmail: "Tu email",
      subject: "Asunto",
      subjectPlaceholder: "¿Cómo podemos ayudarte?",
      message: "Mensaje",
      messagePlaceholder: "Describe tu problema o pregunta en detalle...",
      send: "Enviar mensaje",
      sending: "Enviando...",
      messageSent: "¡Mensaje enviado con éxito!",
      sendError: "Error al enviar. Inténtalo de nuevo.",
      thankYou: "¡Mensaje enviado!",
      thankYouDesc: "Gracias por contactarnos. Te responderemos en menos de 24 horas.",
      sendAnother: "Enviar otro mensaje",
    },
    // Payment Links
    links: {
      title: "Enlaces de pago",
      subtitle: "Crea y gestiona tus enlaces de pago",
      create: "Crear enlace",
      edit: "Editar",
      delete: "Eliminar",
      noLinks: "Sin enlaces de pago",
      createFirst: "Crea tu primer enlace de pago",
      linkTitle: "Título",
      description: "Descripción",
      price: "Tu precio",
      customerPrice: "El cliente paga",
      currency: "Moneda",
      previewImage: "Imagen de vista previa",
      blurPreview: "Desenfocar vista previa",
      blurPreviewDesc: "Desenfocar la vista previa hasta la compra",
      buttonText: "Texto del botón",
      successMessage: "Mensaje de éxito",
      uploadMedia: "Subir archivo",
      uploadMediaDesc: "Haz clic para subir tu contenido digital",
      uploadMediaTypes: "PDF, Vídeo, Imagen o cualquier tipo de archivo",
      clickToChange: "Haz clic para cambiar el archivo",
      replaceMedia: "Reemplazar",
      removeMedia: "Eliminar",
      mediaRemoved: "Medio eliminado",
      copyLink: "Copiar enlace",
      linkCopied: "¡Enlace copiado!",
      preview: "Vista previa",
      copied: "Copiado!",
      views: "Vistas",
      sales: "Ventas",
      active: "Activo",
      inactive: "Inactivo",
      priceNote: "El cliente pagará 10% más",
      revenue: "Ingresos",
      titlePlaceholder: "ej: Curso de vídeo premium",
      descriptionPlaceholder: "Describe tu contenido digital...",
      pricePlaceholder: "9.99",
      buttonTextPlaceholder: "Comprar",
      successMessagePlaceholder: "¡Gracias por tu compra!",
      linkUpdated: "¡Enlace de pago actualizado!",
      linkCreated: "¡Enlace de pago creado!",
      mediaUploaded: "¡Archivo multimedia subido!",
      linkDeleted: "Enlace de pago eliminado",
      failedToLoad: "Error al cargar los enlaces",
      failedToSave: "Error al guardar",
      failedToDelete: "Error al eliminar",
      saving: "Guardando...",
      confirmDelete: "¿Estás seguro de que quieres eliminar este enlace?",
    },
    // Settings
    settings: {
      title: "Configuración",
      subtitle: "Gestiona la configuración de tu cuenta y preferencias",
      profile: "Perfil",
      profileDesc: "Actualiza tu información personal",
      branding: "Marca",
      appearance: "Apariencia",
      appearanceDesc: "Personaliza el tema de tu interfaz",
      language: "Idioma",
      languageDesc: "Elige tu idioma preferido",
      darkMode: "Modo oscuro",
      lightMode: "Modo claro",
      saveChanges: "Guardar cambios",
      saving: "Guardando...",
      bio: "Biografía",
      bioPlaceholder: "Cuéntale a tu audiencia sobre ti...",
      storeSlug: "URL de tienda",
      avatar: "Avatar",
      uploadAvatar: "Subir avatar",
      removeAvatar: "Eliminar foto",
      avatarRemoved: "Foto eliminada",
      profileUpdated: "¡Perfil actualizado!",
      failedToUpdate: "Error al actualizar el perfil",
      toggleTheme: "Alternar entre modo claro y oscuro",
      cleanBright: "Limpio y brillante",
      easyOnEyes: "Fácil para los ojos",
      interfaceLanguage: "Idioma de la interfaz",
    },
    // Store
    store: {
      title: "Tu tienda",
      subtitle: "Previsualiza y comparte tu tienda pública",
      preview: "Vista previa",
      products: "Productos",
      noProducts: "Sin productos disponibles",
      items: "artículos",
      storeUrl: "URL de tu tienda pública",
      copyUrl: "Copiar URL",
      copied: "¡Copiado!",
      storePreview: "Vista previa de la tienda",
      createToShow: "Crea enlaces de pago para mostrar productos en tu tienda",
      storeNotFound: "Tienda no encontrada",
      storeNotFoundDesc: "Esta tienda no existe o ha sido eliminada.",
      poweredBy: "Impulsado por",
      securePayments: "Pagos seguros",
      noProductsCreator: "Este creador aún no ha añadido productos.",
      buyNow: "Comprar",
    },
    // Payment
    payment: {
      pay: "Pagar",
      processing: "Procesando...",
      success: "¡Pago exitoso!",
      thankYou: "Gracias por tu compra",
      download: "Descargar contenido",
      accessContent: "Acceder al contenido",
      methods: "Métodos de pago",
      creditCard: "Tarjeta de crédito",
      applePay: "Apple Pay",
      selectMethod: "Seleccionar método de pago",
      securePayment: "Pago seguro a través de Stripe",
      premiumContent: "Contenido premium",
      unlockedAfterPurchase: "Desbloqueado después de la compra",
      securePaymentBadge: "Pago seguro",
      instantDelivery: "Entrega instantánea",
      creator: "Creador",
      linkNotFound: "Enlace no encontrado",
      linkNotFoundDesc: "Este enlace de pago no existe o ha sido eliminado.",
      verifyingPayment: "Verificando pago...",
      pleaseWait: "Por favor espera mientras confirmamos tu pago",
      paymentProcessing: "Procesando pago",
      paymentStillProcessing: "Tu pago todavía se está procesando. Esto puede tardar un momento.",
      checkAgain: "Verificar de nuevo",
      sessionExpired: "Sesión expirada",
      sessionExpiredDesc: "Tu sesión de pago ha expirado. Por favor, inténtalo de nuevo.",
      somethingWrong: "Algo salió mal",
      somethingWrongDesc: "No pudimos verificar tu pago. Si se te cobró, por favor contacta con soporte.",
      goBack: "Volver",
      tryAgain: "Intentar de nuevo",
      yourPurchase: "Tu compra",
      saveThisPage: "Guarda esta página para acceder a tu contenido más tarde",
      mediaPrice: "Precio del contenido",
      platformCommission: "Comisión plataforma (10%)",
      totalToPay: "Total a pagar",
      commissionNote: "Esta pequeña comisión garantiza transacciones rápidas, seguras y una entrega fiable del contenido.",
      videoNotSupported: "Tu navegador no soporta la reproducción de video.",
      checkoutFailed: "No se pudo iniciar el pago. Por favor, inténtalo de nuevo.",
      noCheckoutUrl: "La sesión de pago no se pudo inicializar. Por favor, reintenta.",
    },
    // Withdraw
    withdraw: {
      title: "Retirar dinero",
      subtitle: "Gestiona tus ganancias y pagos",
      availableBalance: "Saldo disponible",
      pendingBalance: "Saldo pendiente",
      totalWithdrawn: "Total retirado",
      withdrawFunds: "Retirar fondos",
      withdrawalsOpen: "Los retiros están abiertos. Se permite un retiro por semana.",
      payoutMethod: "Método de pago",
      payoutMethods: "Métodos de pago",
      bankTransfer: "Transferencia bancaria",
      addBankAccount: "Añadir cuenta bancaria",
      addMethod: "Añadir método",
      bankDetails: "Datos bancarios",
      fullName: "Nombre completo",
      fullNamePlaceholder: "Juan García",
      iban: "IBAN",
      ibanPlaceholder: "ES76 XXXX XXXX XXXX XXXX XXXX",
      bic: "BIC/SWIFT",
      bicPlaceholder: "XXXXXXXX",
      bankName: "Nombre del banco",
      bankNamePlaceholder: "Nombre del banco",
      country: "País",
      withdrawAmount: "Cantidad a retirar",
      minWithdraw: "Retiro mínimo",
      available: "Disponible",
      history: "Historial de retiros",
      historyDesc: "Tu historial de retiros",
      noHistory: "Sin retiros",
      pending: "Pendiente",
      completed: "Completado",
      failed: "Fallido",
      requestWithdraw: "Solicitar retiro",
      saveAccount: "Guardar cuenta",
      editAccount: "Editar cuenta",
      deleteAccount: "Eliminar cuenta",
      methodUpdated: "¡Método de pago actualizado!",
      methodAdded: "¡Método de pago añadido!",
      methodDeleted: "Método de pago eliminado",
      withdrawalSubmitted: "¡Solicitud de retiro enviada!",
      failedToSave: "Error al guardar",
      failedToDelete: "Error al eliminar",
      failedToRequest: "Error al solicitar el retiro",
      noMethodsAdded: "Sin métodos de pago añadidos",
      addMethodDesc: "Añade una cuenta bancaria para retirar fondos",
      confirmDeleteMethod: "¿Estás seguro de que quieres eliminar este método de pago?",
      managePayoutMethods: "Gestiona tus métodos de pago",
    },
    // Common
    common: {
      loading: "Cargando...",
      error: "Ocurrió un error",
      save: "Guardar",
      cancel: "Cancelar",
      confirm: "Confirmar",
      search: "Buscar",
      filter: "Filtrar",
      sort: "Ordenar",
      actions: "Acciones",
      status: "Estado",
      date: "Fecha",
      amount: "Monto",
      back: "Volver",
      next: "Siguiente",
      submit: "Enviar",
      close: "Cerrar",
      edit: "Editar",
      delete: "Eliminar",
      view: "Ver",
      copy: "Copiar",
      share: "Compartir",
      download: "Descargar",
      upload: "Subir",
      yes: "Sí",
      no: "No",
      or: "o",
      and: "y",
      of: "de",
      to: "a",
      from: "de",
    },
    // Errors
    errors: {
      required: "Este campo es obligatorio",
      invalidEmail: "Dirección de correo inválida",
      passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
      passwordMismatch: "Las contraseñas no coinciden",
      networkError: "Error de red. Por favor, inténtalo de nuevo.",
      unauthorized: "No estás autorizado para realizar esta acción",
      notFound: "Recurso no encontrado",
      serverError: "Error del servidor. Por favor, inténtalo más tarde.",
    },
    // Success messages
    success: {
      saved: "Cambios guardados exitosamente",
      deleted: "Eliminado exitosamente",
      copied: "Copiado al portapapeles",
      updated: "Actualizado exitosamente",
    },
  },
};

export const languages = [
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "es", name: "Español", flag: "🇪🇸" },
];
